/* eslint-disable  */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCookie } from '@/Services/Storage Services';
import { authServices, notificationServices } from '@/Services';
import { navigationActions, featureFlagsActions } from '@/Actions';
import modulesConfiguration from '@/Services/modulesConfiguration.services';

function useAuthInit(props) {
	const { signIn, setAppConfig, setUserConfig, signout, setUserStores } =
		props;
	const [fetchedConfig, setFetchedConfig] = useState(false);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const checkToken = async () => {
		const isValid = await authServices.checkToken();
		if (isValid) {
			const stores = JSON.parse(localStorage.getItem('userStores'));
			setUserStores(stores);
			const userRoles = {};
			const userLevels = {};
			const storedAppConfig = JSON.parse(getCookie('user'));
			stores?.forEach((store) => {
				store?.levels?.forEach((roleAndLevel) => {
					userRoles[roleAndLevel.roleId] = true;
					userLevels[roleAndLevel.levelId] = true;
				});
			});
			dispatch(
				navigationActions.updateUserPermittedStores({
					userStores: stores,
				})
			);
			if (Object.keys(userRoles).length > 0) {
				dispatch(
					navigationActions.handleUserRolesNavItem({
						userRoles,
					})
				);
				dispatch(
					navigationActions.updateUserPermissionsBasedOnLevels({
						userLevels: Object.keys(userLevels),
						internal: storedAppConfig.internal,
						accToInternal: true,
					})
				);
			}
			signIn(storedAppConfig);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	const fetchAppConfig = (autoLogin = false) => {
		authServices.fetchAppConfig().then(
			(res) => {
				const { data } = res;
				localStorage.setItem('appConfig', JSON.stringify(data));
				setAppConfig(data);
				dispatch(navigationActions.updateNavPermissions());
				// Initialize feature flags based on customerId from appConfig
				dispatch(
					featureFlagsActions.initializeFeatureFlags(data?.customerId)
				);
				setFetchedConfig(true);
				// setCookie('appConfig',JSON.stringify(res.data),30);
				setUserConfig(JSON.parse(getCookie('user')));
				if (autoLogin) {
					checkToken();
				} else {
					setLoading(false);
				}
			},
			(err) => {
				setLoading(false);
				notificationServices.generateNotification({
					type: 'error',
					message: err,
				});
			}
		);
	};

	const updateNavState = async () => {
		try {
			const navStateRolesMapped =
				await modulesConfiguration.getModulesConfiguration();
			dispatch(
				navigationActions.updateNavStateRolesMapping({
					rolesConfig: navStateRolesMapped.data,
				})
			);
		} catch (err) {
			// eslint-disable-next-line no-console
			console.log(err);
		}
	};

	useEffect(() => {
		if (!signout) {
			if (getCookie('user')) {
				fetchAppConfig(true);
			} else {
				fetchAppConfig();
			}
		} else {
			fetchAppConfig();
		}
		updateNavState();
	}, []);

	return { loading, fetchedConfig };
}
export default useAuthInit;
